module.exports = __webpack_public_path__ + "img/Users-background-gray.d1e91961.svg";